<template>
  <div class="TextStudy">
    <div class="p-2 i-theme-color rounded-1">
      <h1 class="mx-2">Study</h1>
      <div class="m-2">
        <button @click="onPreviousButtonClicked">&lt;</button>
        <input ref="searchInput" v-model="data.passage" @change="search" />
        <button @click="onNextButtonClicked">&gt;</button>
        <input id="rootToggle" class="mx-1" type="checkbox" @change="onRootToggleChange" />
        <label for="rootToggle">Show roots</label>
      </div>
    </div>
    <div class="p-2 text-center" v-if="loading">Loading...</div>
    <div class="p-2 scroll-overflow" style="max-height: 62vh;" v-if="!loading">
      <div v-if="data.type == 'verse'" class="verse">
        <div v-for="word in data.words" :key="word.id" class="p-1 float-right">
          <table class="text-center" style="float: right">
            <tbody>
              <tr>
                <td class="hebrew">{{ word.passage }}</td>
              </tr>
              <tr>
                <td><small @click="onWordClicked" class="clickable">{{ word.transliteration }}</small></td>
              </tr>
              <tr class="roots" v-show="!rootsHidden">
                <td><small @click="onWordClicked" class="clickable">{{ word.root }}</small></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else-if="data.type == 'chapter'">
        <div v-for="verse in data.verses" :key="verse.id" class="verse px-1 float-right">
          <div class="p-1 float-right" style="height: 4em;">
            <table>
              <tbody>
                <tr>
                  <td>{{ verse.passage.replace(data.passage+':','') }}</td>
                </tr>
                <tr>
                  <td></td>
                </tr>
                <tr class="roots" v-show="!rootsHidden">
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-for="word in verse.words" :key="word.id" class="px-1 float-right">
            <table class=" text-center" style="float: right">
              <tbody>
                <tr>
                  <td class="hebrew">{{ word.passage }}</td>
                </tr>
                <tr>
                  <td><small @click="onWordClicked" class="clickable">{{ word.transliteration }}</small></td>
                </tr>
                <tr class="roots" v-show="!rootsHidden">
                  <td><small @click="onWordClicked" class="clickable">{{ word.root }}</small></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextStudy',
  props: {
    backendURL: String,
  },
  data() {
    return {
      data: {
        passage: 'Genesis 1:1',
      },
      rootsHidden: true,
      position: 'same',
      searchUrl: '/study',
      publicPath: process.env.BASE_URL,
      loading: false,
    }
  },
  mounted() {
    if (this.$route.params.passage) {
      this.data.passage = this.$route.params.passage;
    }
    this.search();
  },
  methods: {
    search() {
      if (!this.data.passage) {
        this.data.passage = 'Genesis 1:1';
      }
      console.log(document.cookie);
      this.$router.push(this.publicPath + 'passage/' + this.data.passage);
      try {
        this.$apiClient.post(this.searchUrl, {'passage': this.data.passage, 'position': this.position})
          .then(
            response => (this.data = response.data,
            this.loading = false)
          );
      this.loading = true;
      } catch (err) {
        console.error(err);
      }
      this.position = 'same';
    },
    onWordClicked() {
      if (event) {
        this.$emit('wordClicked', event.target.textContent);
      }
    },
    onPreviousButtonClicked() {
      if (!this.data.passage) {
        this.data.passage = 'Genesis 1:1';
      }
      this.position = 'previous';
      this.search();
    },
    onNextButtonClicked() {
      if (!this.data.passage) {
        this.data.passage = 'Genesis 1:1';
      }
      this.position = 'next';
      this.search();
    },
    onRootToggleChange() {
      this.rootsHidden = !event.target.checked;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clickable:hover {
  cursor: pointer;
  background-color: yellow;
}
.hebrew {
  font-size: 1.5em;
}
.verse:hover {
  background-color: #d8d0ce;
}
/* .roots {
}
.roots[hidden] {
  display: none;
} */
</style>
